<template>
  <div id="signature-v1-l6rrm3">
    <b-form-group id="signature-v1-1klvjr"
      v-if="showType == 'form-builder'"
      :description="properties.description"
      :label="properties.label"
      :style="properties.style"
    >
      <b-button id="signature-v1-ucm9da" size="sm">Click to Sign</b-button>
    </b-form-group>
    <div id="signature-v1-zmscb9" v-if="showType == 'properties'">
      <signature-v1-properties id="signature-v1-hr7clx" :formId="formId" />
    </div>
    <b-form-group id="signature-v1-8sxw8a"
      style="font-size: 14px"
      v-if="
        (showType == 'form-submitter' && page == currentPage) ||
          (showType == 'e-form' && properties.eFormEditable)
      "
      :description="
        computedConditions.description
          ? computedPropertiesForm.description
          : properties.description
      "
      :label="
        computedConditions.label
          ? computedPropertiesForm.label
          : properties.label
      "
      :style="properties.style"
      :hidden="computedHidden"
      :state="state"
      :invalid-feedback="errors.join(', ')"
    >
      <div id="signature-v1-60uyh1" class="sign-result" v-if="controlValue">
        <img id="signature-v1-fbvkl7" style="width: 100%;" :src="controlValue.signature" />
        <div id="signature-v1-e8pzhj" class="text-center border-top">
          <small id="signature-v1-wfkz9x">{{ controlValueSigner }} </small><br id="signature-v1-xeau4g" />
          <small id="signature-v1-ewetrj">{{ formatDate(controlValue.date) }}</small>
        </div>
      </div>
      <div id="signature-v1-jyv26t" class="d-flex justify-content-between sign-result mt-2">
        <b-button id="signature-v1-isrex1" v-if="!controlValue" @click="showSignPadShown" size="sm"
          >Click to Sign</b-button
        >
        <b-button id="signature-v1-tjsoyb"
          v-if="controlValue"
          @click="clearSignatureForm"
          variant="danger"
          size="sm"
          class="ml-2"
          >Clear</b-button
        >
      </div>

      <b-modal id="signature-v1-maneev"
        v-model="signPadShown"
        title="Please Sign"
        @ok="saveSignature"
        @cancel="disconectSigWeb()"
        @hide="disconectSigWeb()"
        centered
        size="md"
        no-close-on-backdrop
        header-bg-variant="primary"
        header-text-variant="white"
        @show="initializeTopazPad()"
        header-class="bg-purple"
      >
        <template v-slot:modal-footer="{ ok, cancel }">
          <div id="signature-v1-kowyfs" class="d-flex flex-row justify-content-between w-100">
            <div id="signature-v1-c0y0pt">
              <b-button id="signature-v1-kurh9y"
                variant="primary"
                @click="useMySignature"
                v-if="
                  currentUser &&
                    currentUser.signature &&
                    properties.type != 'client'
                "
              >
                Use My Signature
              </b-button>
            </div>
            <div id="signature-v1-1u9kmf">
              <b-button id="signature-v1-4cda2p"
                class="bg-med-light-gray"
                variant="light"
                @click="cancel()"
              >
                Cancel
              </b-button>
              <b-button id="signature-v1-sx6kp7" class="ml-2" variant="primary" @click="ok()">
                Ok
              </b-button>
            </div>
          </div>
        </template>
        <template v-slot:modal-ok="{}">Ok</template>
        <template v-slot:modal-cancel="{}">Cancel</template>
        <b-form-group id="signature-v1-cg5me3" v-if="isTopazIntalled" label="Mode">
          <b-form-radio-group id="signature-v1-in2e4p" v-model="padType">
            <b-row id="signature-v1-owuo1e">
              <b-col id="signature-v1-ai27is">
                <b-form-radio id="signature-v1-ocjkc3" value="topaz">Topaz</b-form-radio>
              </b-col>
              <b-col id="signature-v1-2tk2n1">
                <b-form-radio id="signature-v1-bcqeft" value="mouse">Mouse</b-form-radio>
              </b-col>
            </b-row>
          </b-form-radio-group>
        </b-form-group>
        <div id="signature-v1-zec3vs" class="d-flex flex-row justify-content-center">
          <div id="signature-v1-nn2n8n">
            <VueSignaturePad id="signature-v1-0r9liv"
              class="border mx-auto"
              width="350px"
              height="150px"
              ref="signaturePad"
              :style="{ display: padType == 'mouse' ? 'block' : 'none' }"
            />
            <canvas id="signature-v1-kw5ti1"
              :style="{ display: padType == 'topaz' ? 'block' : 'none' }"
              class="border mx-auto"
              ref="topaz-canvas"
              width="350"
              height="150"
            />
            <div id="signature-v1-0z9691" class="d-flex flex-row justify-content-end mt-1">
              <a id="signature-v1-w3vuhc" href="#" @click.prevent.stop="clearSignature">Clear All</a>
            </div>
          </div>
        </div>
        <div id="signature-v1-r1ezap">
          <b-form-group id="signature-v1-zdulea"
          v-if="properties.type == 'general'" 
          label="Signed By">
            <b-form-input id="signature-v1-bumwb9"
              v-model="signedBy"
              maxLength="50"
            ></b-form-input>
        </b-form-group>
        </div>
        <div id="signature-v1-dbuesh"
          v-if="properties.dateEditable"
          class="d-flex flex-row justify-content-center"
          style="width: 350px;"
        >
          <b-form-group id="signature-v1-luafut"
            class="d-flex justify-content-center"
            label="Date & Time"
          >
            <date-time-picker id="signature-v1-6bi2xf" v-model="dateTime" />
          </b-form-group>
        </div>
      </b-modal>
    </b-form-group>
    <b-form-group id="signature-v1-vg8jwl"
      v-if="
        showType == 'form-viewer' ||
          (showType == 'e-form' && !properties.eFormEditable)
      "
      :label="
        computedConditions.label
          ? computedPropertiesForm.label
          : properties.label
      "
    >
      <div id="signature-v1-hcvmb4" class="sign-result" v-if="controlValue">
        <img id="signature-v1-i91ng9" style="width: 100%;" :src="controlValue.signature" />
        <div id="signature-v1-14iotf" class="text-center border-top">
          <small id="signature-v1-h0tmd9">{{ controlValueSigner }}</small
          ><br id="signature-v1-m5wnpi" />
          <small id="signature-v1-280zrg">{{ formatDate(controlValue.date) }}</small>
        </div>
      </div>
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import {
  formatDate,
  formatDateTimeMysql,
  formatDateTimeSql
} from "../../../../helpers/date";
import SignatureV1Properties from "./SignatureV1Properties.vue";
import DateTimePicker from "../../../controls/DateTimePicker";
import { getComponentBaseId } from "../../../../helpers/formBuilder";

let tabletState = null;

export default {
  name: "SignatureV1",
  components: { SignatureV1Properties, DateTimePicker },
  props: ["showType", "properties", "form", "id", "results", "formId", "page", "componentsIdSuffix"],

  data() {
    return {
      signPadShown: false,
      computedProperties: ["description", "label", "hidden"],
      computedConditions: {},
      padType: "mouse",
      dateTime: null,
      signedBy: ""
    };
  },
  mounted() {
    const baseId = getComponentBaseId(this.id);
    if (
      !this.getFormSubmitterComponentValue(baseId) &&
      (this.showType == "form-submitter" || this.showType == "e-form")
    ) {
      this.setFormSubmitterComponentValue({
        controlId: baseId,
        controlValue: this.properties.value
      });
      if(this.componentsIdSuffix) {
        this.initializeComponentValue({
          controlId: baseId,
          properties: this.properties
        });
      }
    }

    this.computeConditions();
  },
  methods: {
    ...mapActions("formSubmitter", ["setFormSubmitterComponentValue", "computeFormSubmitterValue", "initializeComponentValue"]),
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    showSignPadShown() {
      this.signPadShown = true;
      this.dateTime = this.getDateTimeBySelectedLocationOrEocLocation
        ? formatDateTimeMysql(this.getDateTimeBySelectedLocationOrEocLocation(this.client.episodeOfCare?.location?.id))
        : formatDateTimeMysql(this.getCurrentAdjustedDateTime());
      setTimeout(() => {
        this.$refs.signaturePad.resizeCanvas();
      }, 250);
    },
    formatDate(date) {
      return formatDate(date);
    },
    saveSignature(bvModalEvt) {
      bvModalEvt.preventDefault();
      if (this.padType == "topaz") {
        window.SetSigCompressionMode(1);
        let signatureString = window.GetSigString();
        let signatureCanvas = this.$refs["topaz-canvas"];
        let canvasContext = signatureCanvas.getContext("2d");
        window.SetDisplayXSize(440);
        window.SetDisplayYSize(100);
        window.SetJustifyMode(0);
        window.ClearTablet();
        window.SetSigCompressionMode(1);
        window.SetSigString(signatureString, canvasContext);
        window.SetJustifyMode(5);
        window.SetTabletState(0, tabletState);
        let imgSignature = signatureCanvas.toDataURL();
        this.controlValue = {
          signature: `${imgSignature}`,
          ...this.getSignatureMetadata()
        };

        this.disconectSigWeb();
        this.signPadShown = false;
      } else {
        const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
        if (!isEmpty) {
          this.controlValue = {
            signature: data,
            ...this.getSignatureMetadata()
          };
        }
        this.disconectSigWeb();
        this.signPadShown = false;
      }
    },
    sigImageCallback(data) {
      this.controlValue = {
        signature: `data:image/png;base64,${data}`,
        ...this.getSignatureMetadata()
      };

      this.disconectSigWeb();
      this.signPadShown = false;
    },
    disconectSigWeb() {
      if (this.isTopazIntalled) {
        window.ClearTablet();
        window.SetTabletState(0, tabletState);
        clearInterval(tabletState);
      }
      this.signedBy = "";
    },
    clearSignature() {
      if (this.$refs.signaturePad) {
        this.$refs.signaturePad.clearSignature();
      }
      if (this.isTopazIntalled) {
        window.ClearTablet();
      }
    },
    clearSignatureForm() {
      this.controlValue = null;
    },
    useMySignature() {
      this.controlValue = {
        signature: this.currentUser.signature,
        ...this.getSignatureMetadata()
      };
      this.signPadShown = false;
    },
    initializeTopazPad() {
      const self = this;
      setTimeout(() => {
        try {
          self.padType = self.isTopazIntalled ? "topaz" : "mouse";
          if (self.isTopazIntalled) {
            let signatureCanvas = self.$refs["topaz-canvas"];
            let canvasContext = signatureCanvas.getContext("2d");
            window.SetDisplayXSize(500);
            window.SetDisplayYSize(100);
            window.SetTabletState(0, tabletState);
            window.SetJustifyMode(0);
            tabletState =
              window.SetTabletState(1, canvasContext, 50) || tabletState;
            window.ClearTablet();
          }
        } catch (e) {
          self.isTopazIntalled = false;
          // If exception throws, means the current machine doesn't have the SignaturePad driver.
        }
      }, 250);
    },
    getSignatureMetadata() {
      return {
        date: formatDateTimeSql(
          this.properties.dateEditable
            ? this.dateTime
            : this.getDateTimeBySelectedLocationOrEocLocation
                ? this.getDateTimeBySelectedLocationOrEocLocation(this.client.episodeOfCare?.location?.id)
                : this.getCurrentAdjustedDateTime()
        ),
        user: this.currentUser
          ? {
              firstName: this.currentUser.firstName,
              lastName: this.currentUser.lastName,
              middleName: this.currentUser.middleName,
              credential: this.currentUser.credential
            }
          : "",
        client: this.client
          ? {
              firstName: this.client.firstName,
              middleName: this.client.middleName,
              lastName: this.client.lastName,
              mrn: this.client.mrn
            }
          : "",
        signedBy: this.signedBy
      };
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm
        ? this.computedPropertiesForm[property] != null
          ? this.computedPropertiesForm[property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      const hidden = this.getComponentComputedProperties(
        "hidden"
      );

      if(hidden === true)
        return "";
        
      return `
      <fieldset aria-describedby="" class="form-group">
        <legend style="font-size: 14px" tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">${this.getComponentComputedProperties(
          "label"
        )}</legend>
        <div tabindex="-1" role="group" class="bv-no-focus-ring">
          ${
            this.controlValue
              ? `
          <div style="max-width: 350px; width: 100%;">
            <img style="width: 100%;" src="${this.controlValue.signature}" />
            <div class="text-center border-top">
              <small>${this.controlValueSigner}</small
              ><br />
              <small>${formatDate(this.controlValue.date)}</small>
            </div>
          </div>
          `
              : ""
          }
        </div>
      </fieldset>`;
    }
  },
  computed: {
    ...mapState("formSubmitter", {
      formErrors: state => state.form.errors,
      client: state => state.form.client,
      currentPage: state => state.form.currentPage
    }),
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue"
    ]),
    ...mapState("layout", {
      currentUser: state => state.currentUser,
      isTopazIntalled: state => state.isTopazIntalled
    }),
    computedPropertiesForm() {
      return this.$store.state.formSubmitter.form.computedProperties[this.id] ?? this.properties;
    },
    ...mapGetters("layout", ["getCurrentAdjustedDateTime", "getDateTimeBySelectedLocationOrEocLocation"]),
    controlValue: {
      get() {
        const baseId = getComponentBaseId(this.id);
        if (this.results) return this.results[baseId];
        return this.getFormSubmitterComponentValue(baseId);
      },
      set(newControlValue) {
        if (this.controlValue != newControlValue) {
          const baseId = getComponentBaseId(this.id);
          this.setFormSubmitterComponentValue({
            controlId: baseId,
            controlValue: newControlValue,
            userAction: true,
            hardSet: true
          });
          this.$emit("update-child-control-value", {
            controlId: baseId,
            controlValue: newControlValue
          });
          if (this.properties.onChange) {
            this.computeFormSubmitterValue({
              elementId: this.id,
              property: "onChange",
              value: `computed:(${this.properties.onChange})(${JSON.stringify(
                newControlValue
              )})`,
              defaultValue: null,
              form: this.form,
              statements: true
            });
          }
        }
      }
    },
    controlValueSigner() {
      switch (this.properties.type) {
        case "client":
          return this.formatClient(
            this.controlValue.client.firstName,
            this.controlValue.client.lastName,
            this.controlValue.client.mrn
          );
        case "general":
          return this.controlValue.signedBy;
        default:
          return "";
        case "user":
          return this.formatUser(this.controlValue.user);
      }
    },
    errors: {
      get() {
        const errorId = getComponentBaseId(this.id, this.formErrors);
        return this.formErrors[errorId] ? this.formErrors[errorId] : [];
      }
    },
    state: {
      get() {
        return this.errors.length == 0 ? null : false;
      }
    },
    computedHidden() {
      const hiddenValue = this.computedConditions.hidden
        ? this.computedPropertiesForm.hidden
        : this.properties.hidden

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    }
  },
  watch: {
    padType: function(newValue) {
      if (newValue == "mouse") {
        setTimeout(() => {
          this.$refs.signaturePad.resizeCanvas();
        }, 250);
      }
    }
  }
};
</script>

<style scoped>
.sign-result {
  max-width: 350px;
  width: 100%;
}
</style>